import React, { Component } from 'react';

import { Col, Row, Button, Container, Table, Tabs, Tab}  from 'react-bootstrap';

import {Rest} from "../../Helpers/Rest" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
import PropTypes from 'prop-types';
import Uploads from "../../Components/Uploads/Uploads"
import Form from "../../Components/Form/Form"
import {onlyUnique} from "../../Helpers/Common"

var moment = require('moment'); // require

var method = "create";
var id = false;
export default class FormContainer extends Component {
    
    state = {
        data:{},
        filter: {
            status: 'active'
        },
    }

    componentDidMount = () => {
        method = this.props.match.params.method
        id = this.props.match.params.id

        if(id){
            var rest = new Rest(this)
            rest.request("events", "READ", {id: id}, (res)=>{ 
                this.setState({
                    data: res
                })
            })

            rest.request("event_options", "GET", {}, (res)=>{
                this.setState({
                    event_options: res
                })
            })

            rest.request("currencies", "GET", {}, (res)=>{
                this.setState({
                    currencies: res
                })
            })

            this.load_event_event_options()
            //this.load_event_option_users()
             
        }
    };

    save = () =>{ 
        this.setState({
            errors: false,
            success: false
        })
        var data = this.state.data
        var rest = new Rest(this)
        var rest_method = "CREATE"
        if(method=="edit"){
            rest_method = "UPDATE"
        }
        if(this.state.uploads){
            data['uploads'] = this.state.uploads.map(u=>u.id)
        }
        rest.request("events", rest_method, data, (res)=>{ 
             if(!res.errors){
                 this.setState({
                     success: ["Saved"]
                 })
                 setTimeout(()=>{
                     window.location.href = "/events/list"
                 }, 500)
             }
        })
    }
 
    create_event_even_option = ()=>{
        var rest = new Rest(this)
        this.setState({
            errors: false
        })
        rest.request("event_event_options", "CREATE", {event_id: id, event_option_id: this.state.add_event_option.id}, (res)=>{
            this.load_event_event_options()
        })
    }

    load_event_event_options = ()=>{
        var rest = new Rest(this)
        rest.request("event_event_options", "GET", {event_id: id}, (res)=>{
            this.setState({
                event_event_options: res
            })
        })
    }
  

    save_event_event_options = (index) =>{
        var rest = new Rest(this)
        rest.request("event_event_options", "UPDATE", this.state.event_event_options[index], (res)=>{
            this.setState({
                success: ["Option updated"]
            })
        })
    }

    delete_event_event_options = (index) =>{
        var rest = new Rest(this)
        rest.request("event_event_options", "DELETE", {id: this.state.event_event_options[index].id}, (res)=>{
            this.load_event_event_options()
        })
    }

    _render_options = ()=>{
        return(
            <Row className="mt-3 center">
                <Col> 
                    <h4>Add option to event</h4>
                    <Row>
                        <Col>
                            <Form
                                method={this.props.match.params.method}
                                fields = {
                                [ 
                                    {
                                    name: "id",
                                    label: "Option",
                                    as: "select",
                                    options: this.state.event_options && [{label: "", value: false }].concat(this.state.event_options.map(o=>{
                                        return {
                                            label: o.name,
                                            value: o.id
                                        }
                                    }))
                                    }, 
                                ]
                                }
                                store_to={"add_event_option"}
                                _this = {this}
                            />
                        </Col>
                        <Col className="pt-3 mt-3"> 
                            <Button onClick={this.create_event_even_option}>Add</Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="pb-3" xs={7}>
                            <h4>Added options</h4>
                            {
                                this.state.event_event_options && this.state.event_event_options.map((o, index)=>{
                                    let fields = [ 

                                        {
                                            name: "non_app_registration_count",
                                            label: "Current non App registration count",
                                        },
                                        {
                                            name: "currency_id",
                                            label: "Currency",
                                            as: "select",
                                            options: this.state.currencies 
                                                && (this.state.currencies.map(currency=>{
                                                return {
                                                    label: currency.name,
                                                    value: currency.id
                                                }
                                            }))
                                        }, 
                                        {
                                            name: "price",
                                            label: "Price",
                                        }, 
                                        {
                                            name: "max_for_user",
                                            label: "Limit for user",
                                        }, 
                                        {
                                            name: "use_only_with_event_option_id",
                                            label: "Parent option ("+(this.state.event_options && this.state.event_options.find(x => x.id == o.event_option_id) ? this.state.event_options.find(x => x.id == o.event_option_id).name : "DELETED")+" will automatically added on click on the parent option in App )",
                                            as: "select",
                                            options: this.state.event_options 
                                                && [{label: "", value: false}].concat(this.state.event_options.filter(x=> x.id != o.event_option_id ).map(option=>{
                                                return {
                                                    label: option.name,
                                                    value: option.id
                                                }
                                            }))
                                        }, 
                                        {
                                            name: "get_info_from_user",
                                            label: "Get info from user through text field",
                                            as:"checkbox"
                                        },
                                        {
                                            name: "add_limit_for_event",
                                            label: "Add limit for event",
                                            as:"checkbox"
                                        }   
                                    ]
 
                                    if(this.state.event_event_options[index].add_limit_for_event){
                                        fields.push({
                                            name: "max_for_event",
                                            label: "Limit for event",
                                        })
                                    }

                                    if(this.state.event_event_options[index].get_info_from_user){
                                        fields.push({
                                            name: "get_info_from_user_text",
                                            label: "Label of text field for geting info from user. Examle 'Enter guest name' ",
                                        })
                                    }

                                    return <div key={o.id} className="border p-2 bg-light mt-3">
                                        <span>{index+1 } </span>
                                        <span><b> { this.state.event_options && this.state.event_options.find(x => x.id == o.event_option_id) ? this.state.event_options.find(x => x.id == o.event_option_id).name : "DELETED"}</b></span>
                                        <hr/>
                                        <Form
                                            method={this.props.match.params.method}
                                            fields = {fields}
                                            store_to={"event_event_options"}
                                            store_is_array={true}
                                            store_index={index}
                                            _this = {this}
                                        />
                                        <Button onClick={()=>this.save_event_event_options(index)}>
                                            Save option params
                                        </Button>{" "}
                                        <Button variant="danger" onClick={()=>this.delete_event_event_options(index)}>
                                            Delete
                                        </Button>
                                    </div>
                                })
                            }
                        </Col>
                    </Row>
                    
                </Col>
            </Row>
        )
    }

    _render_general = ()=>{
        return(
            <Row className="mt-3 center">
            <Col>
                <Row className="d-flex justify-content-center">
                    <Col>
                        <Form
                            method={this.props.match.params.method}
                            fields = {
                              [ 
                                {
                                  name: "status",
                                  label: "Status",
                                  as: "select",
                                  options:[
                                        {
                                            label: "draft",
                                            value: "draft"
                                        },
                                        {
                                            label: "active",
                                            value: "active"
                                        },
                                        {
                                            label: "deleted",
                                            value: "deleted"
                                        },
                                  ]
                                },
                                {
                                  name: "name",
                                  label: "Name"
                                },
                                {
                                  name: "max_participators",
                                  label: "Max participators"
                                },
                                {
                                  name: "date",
                                  label: "Event date and time",
                                  as: "datetime"
                                }, 
                                {
                                  name: "address",
                                  label: "Address"
                                },  
                                /*{
                                  name: "coordinates",
                                  label: "Coordinates"
                                }, */
                                {
                                  name: "description",
                                  label: "Description",
                                  as: "html"
                                }, 
                              ]
                            }
                            store_to={"data"}
                            _this = {this}
                        />

                        <div>
                            { this.state.data.id && method==="edit" && <Uploads
                                label={"Add preview image"}
                                max={1}
                                table_name={"events"}
                                record_id={this.state.data.id}
                                variant="preview"
                                base64={true}
                                accept="image/*"
                            />}
                            { method==="create" && <Uploads
                                label={"Add preview image"}
                                max={1}
                                table_name={"events"}
                                variant="preview"
                                base64={true}
                                accept="image/*"
                                returnUploads={(uploads)=>this.setState({uploads:uploads})}
                            />}
                        </div>
                         
                        <Button className="btn-block" variant="dark" onClick={this.save}>
                            Save
                        </Button>
                    </Col>
                </Row> 
            </Col>
        </Row>
        )
    }


    _render_registrations = ()=>{
        var regs = this.state.data && this.state.data.all_registrations && this.state.data.all_registrations || []
        var statuses = regs.map(r=>{
            return ({
                label: r.status,
                value: r.status
            })
        })
        statuses.unshift({
            label: "",
            value: ""
        })
        statuses = onlyUnique(statuses, 'value')


        var options = regs.map(r=>{
            return ({
                label: r.option_name,
                value: r.option_name
            })
        })
        options.unshift({
            label: "",
            value: ""
        })
        options = onlyUnique(options, 'value')


        if(this.state.filter.status){
            regs = regs.filter(x => x.status == this.state.filter.status) 
        }

        if(this.state.filter.option){
            regs = regs.filter(x => x.option_name == this.state.filter.option) 
        }

        if(this.state.filter.member){
            regs = regs.filter(x => {
                return (
                    x.user.name.toLowerCase().indexOf(this.state.filter.member.toLowerCase()) != -1 
                    || x.user.member_number.toString().toLowerCase().indexOf(this.state.filter.member.toLowerCase()) != -1 
                    || x.user.position.toLowerCase().indexOf(this.state.filter.member.toLowerCase()) != -1 
                    || x.user.department.toLowerCase().indexOf(this.state.filter.member.toLowerCase()) != -1 
                )
            }) 
        }

        
        return(
            <Row className="mt-3 center">
                <Col>
                <Form
                            method={this.props.match.params.method}
                            fields = {
                              [ 
                                {
                                  name: "status",
                                  label: "Status",
                                  as: "select",
                                  options: statuses
                                },
                                {
                                  name: "option",
                                  label: "option",
                                  as: "select",
                                  options: options
                                },
                                {
                                  name: "member",
                                  label: "Member info"
                                }, 
                              ]
                            }
                            store_to={"filter"}
                            _this = {this}
                        />
                    <Row>
                        <Col>
                            <b>Results: {regs && regs.length}</b>
                        </Col>
                    </Row>
                    <Table bordered>
                        <thead>
                            <tr >
                                <th>#</th>
                                <th>Created at</th>
                                <th>
                                    Member
                                </th>
                                <th>Registration status</th>
                                <th>Option</th>
                                <th>Comment</th>
                                <th>Price</th>
                                <th>Paid</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                regs.map((r, index)=>{
                                    return (
                                        <tr key={r.id}>
                                            <td>{index+1}</td>
                                            <td>{moment(r.created_at).format('YYYY-MM-DD HH:mm')}</td>
                                            <td>
                                                {r.user.member_number} {" - "}
                                                {r.user.name} <br/>
                                                {r.user.position} {", "}
                                                {r.user.department}
                                            </td>
                                            <td>{r.status}</td>
                                            <td>{r.option_name}</td>
                                            <td>{r.comment}</td>
                                            <td>{r.price} {r.currency.short}</td>
                                            <td>{r.paid ? <div className="paid">YES</div> : <div className="notPaid">NO</div> }</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>
        )
    }

    
  render() {
      console.log(this.state)
    return (
        <Container>
            <Row className="mt-3 mb-3">
            <Col>
                <h4>
                    { method==="edit"? "Edit event option" : "Add event option"}
                </h4>
            </Col>
            </Row>

            {
                this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
            }
            {
                this.state.success && <InfoBlock data={this.state.success} variant="info" />
            }

            <Tabs defaultActiveKey="general" id="uncontrolled-tab-example">
                <Tab eventKey="general" title="General">
                     {this._render_general()}
                </Tab>
                <Tab eventKey="options" title="Options">
                    {this._render_options()}
                </Tab> 
                <Tab eventKey="registrations" title="Registrations">
                    {this._render_registrations()}
                </Tab> 
            </Tabs>
            
            

        </Container>
    );
  }
}
 


FormContainer.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
            method: PropTypes.string
        })
    }), 
}